var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuitar = function SvgGuitar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M12.62 17.9a1.51 1.51 0 0 1 1.24-1.65 3 3 0 0 0 1.66-.83c1.48-1.42 1.1-4.2-.82-6.12S10 7 8.58 8.48a3 3 0 0 0-.83 1.66 1.51 1.51 0 0 1-1.65 1.24 4.7 4.7 0 0 0-4 1.25C.07 14.68.48 18.41 3 21s6.29 3 8.34.91a4.7 4.7 0 0 0 1.28-4.01m5.79-14.427 1.592-1.591s1.06-1.06 2.121 0h0s1.06 1.06 0 2.121l-1.59 1.591s-1.061 1.06-2.122 0h0s-1.06-1.06 0-2.121M18.41 5.59 14.7 9.3M18.94.81 20 1.87M22.13 4l1.06 1.06m-2.65.53 1.06 1.06M17.35 2.4l1.06 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.49 13.01a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m-4.33 3.71 2.12 2.12"
  }))));
};
export default SvgGuitar;